import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel'
import { initThree, camera, renderer, scene, incRenderCount } from './initThree'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Range from 'vux/src/components/range/index.vue'

import loading from '@/components/loading';
import { PenholderMaker, currentMesh } from './PenholderMaker';

const penholder = new PenholderMaker(scene);

export default {
name: "TysonPenHolder",
mixins: [printModel],
components: {
XDialog, Toast, CheckIcon, Range, loading
},

data() {
return {
quotationName: "泰森纹笔筒",
productType: "泰森纹笔筒",
landscape: true,//竖屏状态要一直为true
showPrint: false,
index: [],
penholdList: {
width: 40, // 宽度的一半
height: 40, // 深度的一半
depth: 120, // 高度
makeHole: true,
voronoiReverse: false,
curveCell: true,
},
addCartIndex: -1,
orderIndex: -1,
isreliefBtnIndex: -1,//顶部按钮默认
isSelectCheckBtnIndex: -1,//笔筒类型默认按钮
showLoading: false,
showType: false,//笔筒类型
showProper: false,//笔筒属性
showIcon1: false,
showIcon2: true,
showIcon3: false,
btnsList: [//按钮列表
{
isClick: false,
icon: require("../imgs/笔筒类型.png"),
iconClick: require("../imgs/笔筒类型.png"),
title: "笔筒类型",
},
{
isClick: false,
icon: require("../imgs/笔筒属性.png"),
iconClick: require("../imgs/笔筒属性.png"),
title: "笔筒属性",
},
],
tysonTypeLists: [
{
couponName: "镂空",
checked: true,
},
{
couponName: "反向",
checked: false,
},
{
couponName: "曲线",
checked: false,
}
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;

var mo = function (e) {
e.preventDefault();
}


initThree(scope.$refs.canvas);


scope.$nextTick(function () {
scope.$refs.TysonPenHolder.style.paddingTop = '0px';
scope.$refs.TysonPenHolder.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});


const contentDOM = scope.$refs.TysonPenHolder;

const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}
scope.init3d(contentDOM, camera, renderer, resize1);

setTimeout(() => {
scope.showLoading = false;
scope.init3d(contentDOM, camera, renderer, resize1);
}, 50);

this.$nextTick(function () {
scope.loadData();
incRenderCount();
});
},
methods: {
updateMesh() {
penholder.makeModel();
incRenderCount();
},

chooseHoleItem() {
this.showLoading = true;
setTimeout(() => {
penholder.makeHole = !penholder.makeHole;
this.showIcon1 = !this.showIcon1;
if (this.tysonTypeLists[0].checked) {
this.showIcon2 = false;
this.tysonTypeLists[0].checked = false;
this.tysonTypeLists[1].checked = true;

} else {
this.showIcon2 = true;
this.tysonTypeLists[0].checked = !this.tysonTypeLists[0].checked;
this.tysonTypeLists[1].checked = false;
this.tysonTypeLists[2].checked = false;

}
this.updateMesh();
this.isTopBtn();
this.showLoading = false;
return;
}, 1000);
},

chooseReverseItem() {
if (this.tysonTypeLists[0].checked) {
this.showIcon2 = true;
return;
}
this.showLoading = true;
setTimeout(() => {
penholder.voronoiReverse = !penholder.voronoiReverse;
this.showIcon2 = !this.showIcon2;
if (this.tysonTypeLists[1].checked) {
this.tysonTypeLists[0].checked = false;
this.tysonTypeLists[2].checked = false;
} else {
this.tysonTypeLists[1].checked = !this.tysonTypeLists[1].checked;
this.tysonTypeLists[0].checked = false;
this.tysonTypeLists[2].checked = false;
}
this.updateMesh();
this.isTopBtn();
this.showLoading = false;
return;
}, 1000);
},

chooseCellItem() {
this.showLoading = true;
setTimeout(() => {
penholder.curveCell = !penholder.curveCell;
this.showIcon3 = !this.showIcon3;
this.tysonTypeLists[2].checked = !this.tysonTypeLists[2].checked;
this.updateMesh();
this.isTopBtn();
this.showLoading = false;
return;
}, 1000);
},


handler(index) {
this.isreliefBtnIndex = index;
if (index === 0) {//笔筒类型
this.showType = true;
this.showPrint = false;
this.showProper = false;
this.btnsList[0].isClick = true;
this.btnsList[1].isClick = false;
return;
} else if (index === 1) {//笔筒属性
this.showProper = true;
this.showType = false;
this.showPrint = false;
this.btnsList[1].isClick = true;
this.btnsList[0].isClick = false;
return;
}
},


loadData() {
const scope = this;
penholder.makeMesh(scene);
penholder.refreshSites();
penholder.makeModel();

if (window.localStorage) {
let dataStr = localStorage.getItem("TysonPenHolder");
localStorage.removeItem("TysonPenHolder"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.penholdList.width = data.width;
scope.penholdList.height = data.height;
scope.penholdList.depth = data.depth;
scope.penholdList.makehole = data.makehole;
scope.penholdList.voronoiReverse = data.voronoiReverse;
scope.penholdList.curveCell = data.curveCell;


scope.showLoading = true;

setTimeout(function () {
scope.showLoading = false;
}, 50);
}
}
},


saveData() {
if (window.localStorage) {
let data = {};

data.width = this.penholdList.width;
data.height = this.penholdList.height;
data.depth = this.penholdList.depth;
data.makehole = this.penholdList.makehole;
data.voronoiReverse = this.penholdList.voronoiReverse;
data.curveCell = this.penholdList.curveCell;

localStorage.setItem("TysonPenHolder", JSON.stringify(data));
}
},

isTopBtn() {
this.isreliefBtnIndex = -1;
this.showProper = false;
this.showType = false;
this.showPrint = false;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
},


isSure() {
this.showLoading = true;
setTimeout(() => {
if (currentMesh) {
scene.remove(currentMesh);
currentMesh.geometry.dispose();
}

penholder.width = this.penholdList.width;
penholder.height = this.penholdList.height;
penholder.depth = this.penholdList.depth;
penholder.makeMesh(scene);
this.updateMesh();
this.isTopBtn();
this.showLoading = false;
}, 1000);
},

downloadModels() {
this.showLoading = true;
setTimeout(() => {
let exporter = new THREE.STLExporter();
let group = currentMesh;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });

let filename = "泰森纹笔筒.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
this.showLoading = false;
}, 1000);
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = currentMesh;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},


print() {
this.showLoading = true;
this.isTopBtn();



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showlowpriceHeight = true;

}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showlowpriceHeight = false;

}

if (currentMesh) {
this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
const scope = this;
this.getPrice().then(() => {
scope.showLoading = false;
});
});
}
else {
this.$vux.toast.show({
text: '泰森纹笔筒不能为空',
type: "warn",
time: 2000,
position: "middle",
});
this.updateMesh();
}
},


getModelToPrint() {
let group = currentMesh;
return group;
}
},
computed: {














},
}


// WEBPACK FOOTER //
// ./src/views/makeTysonPenHolder/scripts/TysonPenHolder.js